import { ref } from 'vue';
import { Capacitor } from '@capacitor/core';
import { versionService } from '@/services/supabase/version.service';
import { useAppVersion } from './useAppVersion';
import { Browser } from '@capacitor/browser';

export function useVersionCheck() {
  const { shortVersion } = useAppVersion();
  const showUpdateModal = ref(false);
  const storeUrl = ref<string | undefined>();

  const checkForUpdates = async () => {
    // Ne pas appeler Supabase en dev pour éviter Failed to fetch (localhost → prod/staging)
    if (import.meta.env.DEV) {
      return;
    }

    // La modale de mise à jour est un blocage dur dont l'unique issue est le
    // store. Sur la PWA il n'y a pas de store, et la bonne réponse à une
    // version périmée est un rechargement : contrôler hors natif ne peut donc
    // qu'enfermer un visiteur. La ligne `web` d'app_version_configs est
    // désactivée pour la même raison, mais on ne fait pas dépendre l'issue
    // d'une seule valeur en base, qu'une fausse manœuvre suffirait à rouvrir.
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    try {
      const { required, storeUrl: url } = await versionService.checkUpdateRequired(shortVersion.value);
      
      if (required) {
        storeUrl.value = url;
        showUpdateModal.value = true;
      }
    } catch (e) {
      console.error('❌ [useVersionCheck] Erreur lors du check de version:', e);
    }
  };

  const openStore = async () => {
    if (storeUrl.value) {
      await Browser.open({ url: storeUrl.value });
    }
  };

  // Expose pour test manuel en console
  // if (import.meta.env.DEV) {
  //   (window as any).triggerUpdateModal = () => {
  //     showUpdateModal.value = true;
  //   };
  // }

  return {
    showUpdateModal,
    checkForUpdates,
    openStore,
    currentVersion: shortVersion
  };
}
